import React, { Fragment } from 'react';

interface RegistrationDateProps {
  date: string;
}

const RegistrationDate = ({ date }: RegistrationDateProps) => {
  const [year, month] = date.split('-');
  return (
    <Fragment>
      {month}/{year}
    </Fragment>
  );
};

export default RegistrationDate;
